import React from 'react';
import classNames from 'classnames';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const Button = (props) => {
  const href = useWindowLocationHref();
  const buttonClasses = classNames({
    'link-item-list__button': true,
    'link-item-list__button--double-column':
      props.CurrentPageProps.BlockTypeName === 'DoubleColumnBlock',
  });

  return (
    <>
      {props.LinkUrl && props.LinkText && (
        <a
          data-event-category={href || 'novalue'}
          data-event-action={props.LinkText}
          data-event-name="LinkItemListButton"
          className={buttonClasses}
          href={props.LinkUrl}
        >
          <span data-event-include>{props.LinkText}</span>
        </a>
      )}
    </>
  );
};

export default Button;
